
if (typeof __webpack_require__.e !== "undefined") {
  var _ensureChunk = __webpack_require__.e;
  __webpack_require__.e = function (chunkId) {
    return Promise.resolve(_ensureChunk(chunkId)).catch(function(error) {
      var e = new Event('nuxt:preloadError', { cancelable: true });
      e.payload = error;
      window.dispatchEvent(e);
      throw error;
    });
  };
}
